import { useState } from "react";
import { Dropdown } from "antd";
import {
  FaBitcoin,
  FaChartLine,
  FaCity,
  FaFlag,
  FaGlobeAsia,
  FaLandmark,
  FaMoneyBillWave,
  FaSun,
  FaUniversity,
} from "react-icons/fa";
import buttonStyles from "../styles/ui/ActionButton.module.css";
import styles from "../styles/shared/MarketTypePicker.module.css";

const MARKETS = [
  { key: "crypto", label: "Crypto", icon: FaBitcoin, tone: "crypto" },
  { key: "forex", label: "Forex", icon: FaMoneyBillWave, tone: "forex" },
  { key: "us", label: "US", icon: FaUniversity, tone: "us" },
  { key: "indonesia", label: "Indonesia", icon: FaGlobeAsia, tone: "indonesia" },
  { key: "iran", label: "Iran", icon: FaFlag, tone: "iran" },
  { key: "australia", label: "Australia", icon: FaSun, tone: "australia" },
  { key: "japan", label: "Japan", icon: FaLandmark, tone: "japan" },
  { key: "ksa", label: "KSA", icon: FaCity, tone: "ksa" },
];

function MarketCards({ value, onChange, inline = false, markets = MARKETS }) {
  return (
    <div className={inline ? styles.inlineRow : styles.marketGrid}>
      {markets.map((item) => {
        const Icon = item.icon;
        const selected = (value || "crypto") === item.key;
        return (
          <button
            key={item.key}
            type="button"
            className={`${styles.marketCard} ${styles[item.tone]} ${selected ? styles.selected : ""}`}
            onClick={() => onChange(item.key)}
          >
            <Icon />
            <span>{item.label}</span>
          </button>
        );
      })}
    </div>
  );
}

function MarketTypePicker({ value, onChange, layout = "dropdown", className = "", allowedMarkets }) {
  const [open, setOpen] = useState(false);
  const markets = allowedMarkets?.length
    ? MARKETS.filter((item) => allowedMarkets.includes(item.key))
    : MARKETS;
  const current = markets.find((item) => item.key === (value || "crypto")) || markets[0];
  if (layout === "inline") {
    return (
      <MarketCards
        value={value}
        inline
        markets={markets}
        onChange={onChange}
      />
    );
  }
  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      trigger={["click"]}
      dropdownRender={() => (
        <MarketCards
          value={value}
          markets={markets}
          onChange={(key) => {
            onChange(key);
            setOpen(false);
          }}
        />
      )}
    >
      <li className={`${buttonStyles.button} ${className}`}>
        <span className={buttonStyles.icon}>
          <FaChartLine />
        </span>
        <span>Market type:</span>
        <span className={buttonStyles.value}>{current.label}</span>
      </li>
    </Dropdown>
  );
}

export default MarketTypePicker;
